import { inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { OAuthService } from 'angular-oauth2-oidc'
import { UserDomainService } from '../../shared/domain/user.domain'

export const authGuard = (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
    const oAuthService = inject(OAuthService)
    const userDomainService = inject(UserDomainService)
    const router = inject(Router)

    return new Observable<boolean>((observer) => {
        oAuthService
            .tryLogin()
            .then(() => {
                const currentUrl = window.location.href
                if (!oAuthService.hasValidIdToken()) {
                    oAuthService.initLoginFlow(currentUrl)
                    return
                }
                if (oAuthService.state && currentUrl !== decodeURIComponent(oAuthService.state)) {
                    window.location.href = decodeURIComponent(oAuthService.state)
                }
                userDomainService.loadConnectedUser().subscribe({
                    next: () => {
                        observer.next(true)
                        observer.complete()
                    },
                    error: () => {
                        void router.navigate(['/user-not-authenticated'], { skipLocationChange: false })

                        observer.next(false)
                        observer.complete()
                    },
                })
            })
            .catch(undefined)
    })
}
